// pages/mobile/format.js
// Times are shown in Eastern time, like the WhatsApp dispatch messages they replace.
export const TIME_ZONE = 'America/New_York';

const formatter = (options) => new Intl.DateTimeFormat('en-US', { timeZone: TIME_ZONE, ...options });

const timeFormat = formatter({ hour: 'numeric', minute: '2-digit' });
const dayFormat = formatter({ weekday: 'long', month: 'short', day: 'numeric' });
const shortDayFormat = formatter({ weekday: 'short' });
const dateFormat = formatter({ month: 'short', day: 'numeric' });
const dayKeyFormat = formatter({ year: 'numeric', month: '2-digit', day: '2-digit' });

const parse = (value) => (value ? new Date(value) : null);

export const formatTime = (value) => (parse(value) ? timeFormat.format(parse(value)) : '');

export const formatDay = (value) => (parse(value) ? dayFormat.format(parse(value)) : '');

// "9:41 PM" today, "Mon" within a week, otherwise "Nov 12".
export const formatSent = (value, now = new Date()) => {
  const date = parse(value);
  if (!date) return '';
  if (dayKeyFormat.format(date) === dayKeyFormat.format(now)) return timeFormat.format(date);
  const days = (now - date) / 86400000;
  return days < 7 ? shortDayFormat.format(date) : dateFormat.format(date);
};

export const DISPATCH_TYPE_LABELS = {
  Loader: 'Loader dispatch',
  Salting: 'Salting dispatch',
  Walkway: 'Walkway dispatch',
};

export const mapsLink = (latitude, longitude, address) => {
  if (latitude != null && longitude != null) {
    return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
  }
  return address ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}` : null;
};

export const answerLabel = (status) => {
  const normalized = (status || '').toLowerCase();
  if (normalized === 'confirmed') return 'confirmed';
  if (normalized === 'denied') return 'denied';
  return null;
};
